import React from 'react';
import { createPortal } from 'react-dom';

interface AddPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  /** Tailwind max-width class for the modal (e.g. 'max-w-2xl'). Default: 'max-w-3xl'. */
  maxWidth?: string;
}

const AddPasswordModal: React.FC<AddPasswordModalProps> = ({ isOpen, onClose, children, title = 'Add Credential', maxWidth = 'max-w-3xl' }) => {
  if (!isOpen) return null;

  const modalContent = (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[9998] transition-opacity"
        onClick={onClose}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%' }}
      ></div>

      {/* Modal */}
      <div 
        className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4"
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%' }}
      >
        <div
          className={`bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 w-full ${maxWidth} max-h-[90vh] overflow-hidden flex flex-col`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div className="px-4 lg:px-6 py-3 lg:py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between flex-shrink-0">
            <div>
              <h2 className="text-lg lg:text-xl font-semibold text-gray-900 dark:text-gray-100">
                {title}
              </h2>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              <i className="fa-solid fa-times text-xl"></i>
            </button>
          </div>

          {/* Modal Content - Scrollable */}
          <div className="flex-1 overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </>
  );

  // Render modal to body using portal
  return createPortal(modalContent, document.body);
};

export default AddPasswordModal;

